import Vue from 'vue';
import { NavigationGuardNext, Route } from 'vue-router';
import { waitUntil } from '@/util/promise-util';
export default {
	async permissionGuard(to: Route, from: Route, next: NavigationGuardNext, refresh = true) {
		if (refresh || !Vue.auth.check()) {
			await waitUntil(async () => {
				await Vue.auth.refresh();
				await Vue.auth.fetch();
				return await Vue.auth.check();
			});
		}
		const user = Vue.auth.user();
		const hasAccess = (route: Route): boolean =>
			!route.meta.requiredRoles ||
			route.meta.requiredRoles.some((role: string) => user && user[role] === true);
		if (hasAccess(to)) {
			next();
		} else {
			const name = hasAccess(from) ? from.name || 'home' : 'home';
			next({
				name,
				params: {
					errorMsg: "Sorry you don't have the right access to reach the route requested",
					...(name === from.name ? from.params : {}),
				},
				query: { redirectFrom: to.fullPath },
			});
		}
	},
};
